// 테스트용 목업 데이터
export const mockRequests = [
  {
    "PK": "telegram:646346000:3:-1002709702925",
    "request": "https://n.news.naver.com/article/037/0000036472 요약해줘",
    "status": "SUCCEED_INPROGRESS",
    "updatedAt": "2025-06-10 11:55:33",
    "resultS3Uri": "s3://aigent-results/646346000/summary.txt"
  },
  {
    "PK": "telegram:646346001:4:-1002709702926",
    "request": "오늘 날씨 어때?",
    "status": "SUCCEED",
    "updatedAt": "2025-06-10 12:30:45",
    "resultS3Uri": "s3://aigent-results/646346001/weather.json"
  },
  {
    "PK": "telegram:646346002:5:-1002709702927",
    "request": "주식 시장 분석해줘",
    "status": "FAILED",
    "updatedAt": "2025-06-10 13:15:22"
  },
  {
    "PK": "telegram:646346003:6:-1002709702928",
    "request": "https://www.example.com/article/12345 이 기사 요약해줘",
    "status": "INPROGRESS",
    "updatedAt": "2025-06-10 14:05:10"
  },
  {
    "PK": "telegram:646346004:7:-1002709702929",
    "request": "내일 서울 날씨 알려줘",
    "status": "SUCCEED",
    "updatedAt": "2025-06-10 15:22:18",
    "resultS3Uri": "s3://aigent-results/646346004/forecast.pdf"
  }
];
